module.exports = __webpack_public_path__ + "static/media/country-5.7a37a1a6.jpg";